import {ActionReducer, ActionReducerMap, createFeatureSelector} from '@ngrx/store';
import * as fromStats from '../reducers/stats.reducer';
import * as fromHours from '../reducers/hours.reducer';
import {combineReducers} from '@ngrx/store';

export interface StatisticsState {
  stats: fromStats.StatsState;
  hours: fromHours.HoursState;
}

export const reducers: ActionReducerMap<StatisticsState> = {
  stats: fromStats.reducer,
  hours: fromHours.reducer,
};

export const reducer: ActionReducer<StatisticsState> = combineReducers(reducers);

export const getCandidatesState = createFeatureSelector<StatisticsState>('candidatesFeature');



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/statistics/store/reducers/index.ts